import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { NumberInputFrom } from '@tencent/wb-ext-form';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { ReactElement } from 'react';
import React from 'react';

export interface IReflectionFeature extends IBaseDrawerFeature {
    reflectionInfoInDrawer: any;
    readonly reflectionInfoInModel: any;
    readonly isMultiDifferent: boolean;
    readonly size: number;
    readonly blur: number;
    readonly dist: number;
    readonly opacity: number;
    renderPreset(): ReactElement;
    getPresetMenuContent(props?: { style: React.CSSProperties }): ReactElement;
    handleReflectionChange(value, dragEnd?: boolean, from?: NumberInputFrom);
    updateReflectionProps(onlyChangeUI?: boolean, onPreview?: boolean);
    handleReflectionPresetStyleClick(reflection);
    handleReflectionPresetSytleEnter(reflection);
    handleReflectionPresetStyleMouseLeave();
    handlePresetVisibleChange(visible: boolean);
}

export const IReflectionFeature = Symbol.for('feature:drawer-font-reflection');

DynamicLoaderRegistry.merge(IReflectionFeature, {
    useFactory: async () => {
        const { ReflectionFeature } = await import('./reflection-feature');
        return ReflectionFeature;
    },
    on: loadTask,
});
